import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryDark, brandSecondary, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	select: {
		backgroundColor: brandPrimary,
		border: `1px solid ${brandSecondary}`,
		color: white,
		width: 140,
	},
	selectDropdown: {
		backgroundColor: brandPrimary,
		border: `1px solid ${brandSecondary}`,
	},
	selectItem: {
		color: white,
		':is([data-highlighted])': {
			backgroundColor: brandPrimaryDark,
		},
		':is([data-selected])': {
			backgroundColor: brandPrimaryDark,
		},
	},
});
